import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import './index.less';

function Loader() {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  return (
    <div className="Loader">
      <Spin indicator={antIcon} />
    </div>
  );
}

export default Loader;
